<script setup lang="ts">
const { t } = useI18n()
const localePath = useLocalePath()
</script>

<template>
  <footer class="border-t border-white/5 mt-12">
    <div class="rod-container py-14">
      <div class="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 mb-12">
        <div>
          <NuxtLink :to="localePath('/')" class="flex items-center gap-2.5 font-display font-bold tracking-tight mb-4">
            <span class="inline-grid place-items-center w-10 h-9 rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 text-[#0A0A0F] text-sm font-extrabold tracking-tight">RB</span>
            <span class="text-base">RomBa</span>
          </NuxtLink>
          <p class="text-sm text-[var(--color-text-muted)] leading-relaxed max-w-xs">
            {{ t('footer.tagline') }}
          </p>
        </div>

        <div>
          <div class="text-xs uppercase tracking-wider text-[var(--color-text-dim)] mb-4">{{ t('footer.product') }}</div>
          <ul class="flex flex-col gap-2.5 text-sm text-[var(--color-text-muted)]">
            <li><a :href="`${localePath('/')}#how`" class="hover:text-white transition-colors">{{ t('footer.links.how') }}</a></li>
            <li><a :href="`${localePath('/')}#products`" class="hover:text-white transition-colors">{{ t('footer.links.products') }}</a></li>
            <li><NuxtLink :to="localePath('/couriers')" class="hover:text-white transition-colors">{{ t('footer.links.couriers') }}</NuxtLink></li>
            <li><NuxtLink :to="localePath('/customers')" class="hover:text-white transition-colors">{{ t('footer.links.customers') }}</NuxtLink></li>
          </ul>
        </div>

        <div>
          <div class="text-xs uppercase tracking-wider text-[var(--color-text-dim)] mb-4">{{ t('footer.company') }}</div>
          <ul class="flex flex-col gap-2.5 text-sm text-[var(--color-text-muted)]">
            <li><NuxtLink :to="localePath('/about')" class="hover:text-white transition-colors">{{ t('footer.links.about') }}</NuxtLink></li>
            <li><NuxtLink :to="localePath('/partners')" class="hover:text-white transition-colors">{{ t('footer.links.partners') }}</NuxtLink></li>
            <li><NuxtLink :to="`${localePath('/about')}#contact`" class="hover:text-white transition-colors">{{ t('footer.links.contacts') }}</NuxtLink></li>
            <li><a href="mailto:press@romba.am" class="hover:text-white transition-colors">{{ t('footer.links.press') }}</a></li>
          </ul>
        </div>

        <div>
          <div class="text-xs uppercase tracking-wider text-[var(--color-text-dim)] mb-4">{{ t('footer.legal') }}</div>
          <ul class="flex flex-col gap-2.5 text-sm text-[var(--color-text-muted)]">
            <li><NuxtLink :to="localePath('/terms')" class="hover:text-white transition-colors">{{ t('footer.links.terms') }}</NuxtLink></li>
            <li><NuxtLink :to="localePath('/privacy')" class="hover:text-white transition-colors">{{ t('footer.links.privacy') }}</NuxtLink></li>
            <li><NuxtLink :to="localePath('/agreement')" class="hover:text-white transition-colors">{{ t('footer.links.couriersAgreement') }}</NuxtLink></li>
          </ul>
        </div>
      </div>

      <div class="border-t border-white/5 pt-6 flex flex-wrap items-center justify-between gap-4 text-xs text-[var(--color-text-dim)]">
        <span>{{ t('footer.copyright') }}</span>
        <span>Made with ❤︎ for travelers</span>
      </div>
    </div>
  </footer>
</template>
